import React, { useEffect, useCallback } from "react"
import { connectPagination } from "react-instantsearch-core"
import { IconButton } from "@mui/material"

import useInputValue from "@secureo/common/hooks/useInputValue"

const ChangePage = ({ currentRefinement: currentPage, nbPages: numberOfPages, refine }: Props) => {
	const page = useInputValue(String(currentPage))

	const setPage = useCallback((pageNumber: number) => {
		page.onChange({ target: { value: String(pageNumber) } })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const onSubmit = () => {
		const pageNumber = Math.floor(Number(page.value))

		if (pageNumber === currentPage) return

		if (pageNumber < 1) {
			refine(1)
			setPage(1)
			return
		}

		if (pageNumber > numberOfPages) {
			refine(numberOfPages)
			setPage(numberOfPages)
			return
		}

		refine(pageNumber)
	}

	const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { keyCode, which } = e
		if (keyCode === 13 || which === 13) onSubmit()
	}

	const goToNextPage = () => {
		if (currentPage !== numberOfPages) refine(currentPage + 1)
	}

	useEffect(() => {
		setPage(currentPage)
	}, [currentPage, setPage])

	return (
		<div style={{ color: "#505e5f" }}>
			<span>
				<input
					type="number"
					min={1}
					step={1}
					max={numberOfPages}
					{...page}
					onKeyPress={onKeyPress}
					disabled={numberOfPages === 0}
					style={{
						marginRight: 6,
						marginTop: 3,
						padding: 0,
						borderRadius: 20,
						width: 40,
						height: 38,
						textAlign: "center",
						border: "1px solid rgba(115, 122, 128, 0.4)",
					}}
				/>
				von {numberOfPages}
			</span>
			<IconButton
				aria-label="next-page"
				color="inherit"
				onClick={goToNextPage}
				disabled={currentPage === numberOfPages || numberOfPages === 0}
				style={{ padding: 0, paddingLeft: 3 }}
				size="large"
			>
				&#10141;
			</IconButton>
		</div>
	)
}

const ExposedChangePage = connectPagination(ChangePage)

interface Props {
	currentRefinement: number
	nbPages: number
	refine: (page: number) => void
	createURL: (page: number) => string
}

export default ExposedChangePage
